import React from "react";
import DynamicEditForm from "../../components/AdvanceDynamicEdit/DynamicEditForm";
import { getStoredData } from "../../json/fecthData";

const BillingReciptEdit = () => {
  const billingData = getStoredData()?.[1] || {};

  return (
    <div>
      <h2>Edit {billingData.TitleBilling} Management</h2>
      <DynamicEditForm
        fields={billingData.AdminBilling}
        apiUrl={billingData.ApiBilling}
        successRedirect={billingData.RedirectAdminBilling}
      />
    </div>
  );
};

export default BillingReciptEdit;
